"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrontendMonitoringService = void 0;
exports.initFrontendMonitoring = initFrontendMonitoring;
var _api = require("./api");
var _datadog = require("./frontend_monitoring/datadog");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function initFrontendMonitoring(config) {
  return FrontendMonitoringService.getInstance(new _datadog.DatadogAdapter()).init(config);
}
class FrontendMonitoringService {
  static getInstance(adapter) {
    if (FrontendMonitoringService.instance) {
      return FrontendMonitoringService.instance;
    }
    if (!adapter) {
      throw new Error("No adapter provided to FrontendMonitoringService.getInstance and no existing instance found");
    }
    FrontendMonitoringService.instance = new FrontendMonitoringService(adapter);
    return FrontendMonitoringService.instance;
  }
  constructor(adapter) {
    _defineProperty(this, "adapter", void 0);
    this.adapter = adapter;
  }
  init(config) {
    if (this.adapter.isInitialized()) {
      return this;
    }
    if (config) {
      this.adapter.init(config);
      this.setInitialUserProperties(config);
    } else {
      const userId = new URLSearchParams(window.location.search).get("user");
      const configUrl = userId ? `/api/patient/config/?user=${userId}` : "/api/patient/config/";
      (0, _api.get)(configUrl).then(conf => {
        this.adapter.init(conf);
        this.setInitialUserProperties(conf);
      }).catch(e => {
        console.warn("Unable to load frontend monitoring", e);
      });
    }
    return this;
  }
  identifyUser(id) {
    this.adapter.identifyUser(id);
  }
  setUserProperty(key, value) {
    this.adapter.setUserProperty(key, value);
  }
  isInitialized() {
    return this.adapter.isInitialized();
  }
  trackEvent(name, properties) {
    this.adapter.trackEvent(name, properties);
  }
  setInitialUserProperties(config) {
    if (config.user_public_id) {
      this.identifyUser(config.user_public_id);
    }
    if (config.session_public_id) {
      this.setUserProperty("session_trace_id", config.session_public_id);
    }
    this.setUserProperty("provider_id", config.provider_id);
  }
}
exports.FrontendMonitoringService = FrontendMonitoringService;
_defineProperty(FrontendMonitoringService, "instance", void 0);